import React from 'react'
import { useDispatch } from 'react-redux'
import { DownloadIcon } from '../../../asset/icon/DownloadIcon'
import { IconClose } from '../../../asset/icon/IconClose'
import { PrintIcon } from '../../../asset/icon/PrintIcon'
import { setModalSwitching } from '../../../store/actions/setting'
//@ts-ignore
import s from './PriceDetail.module.scss'
export const PriceDetail = () => {

    const dispatch = useDispatch()
    const onClose = () => {

        dispatch(setModalSwitching({ idModal: 'visiblePrice', conditionModal: false }))
    }

    return (
        <div className={s.wrapModal}>

            <div className={s.icon_close} onClick={() => onClose()}>
                <IconClose />
            </div>

            <header className={s.header}>
                <div className={s.title}>Price Details</div>
                <div className={s.control}>
                    <button>
                        <div className={s.icon}><PrintIcon /></div>
                        <div className={s.name}>Print</div>
                    </button>
                    <button>
                        <div className={s.icon}> <DownloadIcon /> </div>
                        <div className={s.name}>Download</div>
                    </button>
                </div>
            </header>
            <main className={s.main}>
                <div className={s.view}>
                    <div className={s.img}>
                        <img src="/assets/mainUrlich.jpg" alt="" />
                    </div>
                    <div className={s.img}>
                        <img src="/assets/plan.jpg" alt="" />
                    </div>
                </div>
               <div className={s.wrapTable}>
               <div className={s.table}>
                    <div className={s.row}>
                        <div className={s.name}>16*20 The Texan</div>
                        <div className={s.value}>17,956.48</div>
                    </div>
                    <div className={`${s.row} ${s.row_TBottom}`}>
                        <div className={s.name}>Total options:</div>
                        <div className={s.value}>170.54</div>
                    </div>
                    <div className={s.row}>
                        <div className={s.name}>Foundation & Framing Select</div>
                        <div className={s.value}>546.6</div>
                    </div>
                    <div className={s.row}>
                        <div className={s.name}>Security & Climate Select</div>
                        <div className={s.value}>665</div>
                    </div>
                    <div className={s.row}>
                        <div className={s.name}>Trim Select</div>
                        <div className={s.value}>179.6</div>
                    </div>
                    <div className={s.row}>
                        <div className={s.name}>Porch Type</div>
                        <div className={s.value}>0.00</div>
                    </div>
                    <div className={s.row}>
                        <div className={s.name}>Loft Type</div>
                        <div className={s.value}>546.6</div>
                    </div>
                    <div className={s.row}>
                        <div className={s.name}>Siding LP</div>
                        <div className={s.value}>665</div>
                    </div>
                    <div className={s.row}>
                        <div className={s.name}>Window in Door Option</div>
                        <div className={s.value}>546.6</div>
                    </div>
                    <div className={s.row}>
                        <div className={s.name}>Advanced Spacing</div>
                        <div className={s.value}>665</div>
                    </div>
                    <div className={s.row}>
                        <div className={s.name}>Framed Opening</div>
                        <div className={s.value}>179.6</div>
                    </div>
                    <div className={s.row}>
                        <div className={s.name}>Double Window Bank</div>
                        <div className={s.value}>0.00</div>
                    </div>
                    <div className={`${s.row} ${s.row_TBottom}  ${s.row_bold}`}>
                        <div className={s.name}>Subtotal</div>
                        <div className={s.value}>17,767.54</div>
                    </div>
                    <div className={s.row}>
                        <div className={s.name}>Sales Tax</div>
                        <div className={s.value}>1.456</div>
                    </div>
                    <div className={`${s.row} ${s.row_bold} `}>
                        <div className={s.name}>Total Order </div>
                        <div className={s.value}>19,232.80</div>
                    </div>
                    <div className={`${s.row} ${s.row_TBottom} ${s.row_bold}`}>
                        <div className={s.name}>Amount Due</div>
                        <div className={s.value}>9,616.40</div>
                    </div>

                </div>
               </div>
            </main>
        </div>
    )
}
